import type { DeleteScimTokenMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

type DeleteScimTokenInput = { keyId: string };

const mapTrpcResponseToGraphQL = (trpcData: {
  keyId: string;
}): DeleteScimTokenMutation => ({
  delete_scim_token: {
    __typename: 'DeleteScimTokenOutput',
    keyId: trpcData.keyId,
  },
});

export const useDeleteScimTokenTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.scim.deleteToken.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.scim.getConfig.queryKey(),
        });
      },
    }),
  });

  return {
    deleteScimToken: async (
      variables: DeleteScimTokenInput
    ): Promise<DeleteScimTokenMutation> => {
      const result = await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
